import { useState, useEffect } from 'react';
import HomeButtons from '../common/components/HomeButtons';
import News from './News';
import Feedback from '../common/components/Feedback';

function Start() {
    const [activeSection, setActiveSection] = useState('news');

    useEffect(() => {
        // const getBasicData = async () => {
        //     try {
        //         setIsLoading(true);
        //         const authData = AuthData.getAuthData();
        //         const url = `${authData.appFunctionUrl}${GET_GENERAL_DATA_FUNCTION}?code=${authData.azureFunctionKey}`; // Use the constant here
        //         const response = await Fetch(url, authData.clientId);
        //         setData(response);
        //     } catch (error) {
        //         console.error("Error fetching data:", error);
        //     } finally {
        //         setIsLoading(false);
        //     }
        // };

        // getBasicData();
    }, []); // Dependency array ensures this runs only once

    const handleSectionChange = (section) => {
        setActiveSection(section);
    };

    return (
        <div className="home-container">
            <HomeButtons 
                activeSection={activeSection} 
                onSectionChange={handleSectionChange} 
            />
            
            {activeSection === 'news' && <News />}
            
            <Feedback />
        </div>
    );
}

export default Start;